module.exports = __webpack_public_path__ + "img/content_code.d82404c1.png";